import * as clipboard from 'clipboard-polyfill';

export default function copyValue(value) {
  return navigator.clipboard && navigator.clipboard.writeText
    ? navigator.clipboard.writeText(value)
    : clipboard.writeText(value);
}
